'use client';
import { useSearchParams } from 'next/navigation';
import SearchScreen from '@/screen/feed/view/search';

const Search = () => {
  const searchParams = useSearchParams();
  const keywordParam = searchParams?.get('keyword');

  return <SearchScreen keyword={keywordParam || undefined} />;
};

export default Search;
